import styled from 'styled-components'
import theme from 'styles/theme'
import Slider from 'react-slick'
import { fadeInAnimation } from 'styles/animation'
import { Element } from 'react-scroll'

export const Container = styled(Element)`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: ${theme.space[8]} 0 ${theme.space[8]} 0;
  background-color: ${theme.colors.relatedArticlesBackground};
`

export const ProductList = styled.div`
  margin: ${theme.space[6]} 0 0 0;
  scroll-behavior: smooth;
  white-space: nowrap;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const ScrollListContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;

  ${(props) =>
    `justify-content: ${
      props.isProductListOverflowing ? 'flex-start' : 'center'
    };`}
`

export const ArticleContainer = styled.div`
  padding: 0 ${theme.space[2]};
`

export const StyledSlider = styled(Slider)`
  max-width: 100vw;

  animation: ${fadeInAnimation} 0.2s ease-in-out;
  margin: 0 0 0 0;
  padding: 0;

  .slick-slide {
    ${theme.mediaQueries.small} {
      transform: initial;
    }

    ${theme.mediaQueries.xlarge} {
      transform: translateX(calc((100vw / 25)));
    }

    transform: translateX(calc(100vw / 7));
  }

  .slick-list {
    overflow: hidden;
  }
`

export const CarouselControlsWrapper = styled.div`
  position: absolute;
  right: ${theme.space[6]};
  bottom: -${theme.space[8]};
  height: 50px;
  width: 150px;
`
export const HeaderContainer = styled.div`
  text-align: center;

  ${theme.mediaQueries.medium} {
    width: 1180px;
  }
`

export const HeaderEyebrow = styled.div`
  color: ${theme.colors.white};
`

export const HeaderTitle = styled.div`
  color: ${theme.colors.white};
  padding: ${theme.space[2]} ${theme.space[2]} ${theme.space[1]}
    ${theme.space[2]};
`

export const HeaderSubtitle = styled.div`
  color: ${theme.colors.white};
  padding: 0 ${theme.space[2]};
`

export default {
  Container,
  ProductList,
  ArticleContainer,
  ScrollListContainer,
  CarouselControlsWrapper,
  HeaderEyebrow,
  HeaderTitle,
  HeaderSubtitle,
}
